module.exports = __webpack_public_path__ + "static/mask_lo_056-7d524fc4c5778a03ab84e64ac5ba3480.jpg";